import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Les paris sportifs sont-ils légaux en France ?',
      answer:
        'Oui, les paris sportifs sont légaux en France depuis 2010. Tous les bookmakers doivent être licenciés par l\'ANJ (Autorité Nationale des Jeux) pour opérer légalement. Nous ne recommandons que des plateformes possédant cette licence.',
    },
    {
      question: 'Comment choisir le meilleur bookmaker ?',
      answer:
        'Plusieurs critères sont importants : les cotes proposées, la rapidité des retraits, la qualité du service client, les bonus et promotions, et bien sûr la licence ANJ. Utilisez notre outil de comparaison pour trouver celui qui correspond le mieux à vos besoins.',
    },
    {
      question: 'Comment retirer mes gains ?',
      answer:
        'Les méthodes de retrait varient selon les bookmakers. Les plus courantes sont : virement bancaire, carte bancaire, portefeuille électronique (PayPal, Skrill). Les délais varient généralement de quelques heures à 48h selon la méthode choisie.',
    },
    {
      question: 'Les bonus sont-ils vraiment gratuits ?',
      answer:
        'Les bonus de bienvenue sont offerts lors de votre premier dépôt, mais ils sont soumis à des conditions de mise. Vous devez généralement miser le montant du bonus plusieurs fois (souvent 3x) avant de pouvoir retirer les gains. Lisez toujours les conditions générales.',
    },
    {
      question: 'Puis-je annuler un pari ?',
      answer:
        'Cela dépend du bookmaker et du type de pari. Certains offrent une fonction "Cash-out" qui vous permet de clôturer votre pari avant la fin de l\'événement. Renseignez-vous sur les options disponibles sur chaque plateforme.',
    },
    {
      question: 'Que faire en cas de problème avec un bookmaker ?',
      answer:
        'Contactez d\'abord le service client du bookmaker. Si le problème persiste, vous pouvez contacter le médiateur des jeux en ligne ou l\'ANJ. Tous les bookmakers licenciés doivent avoir un processus de médiation.',
    },
    {
      question: 'Dois-je payer des impôts sur mes gains ?',
      answer:
        'En France, les gains de paris sportifs sont exonérés d\'impôts depuis 2019. Vous n\'avez donc pas à déclarer vos gains aux impôts, quelle que soit leur montant.',
    },
    {
      question: 'Puis-je avoir plusieurs comptes chez différents bookmakers ?',
      answer:
        'Oui, vous pouvez avoir des comptes chez plusieurs bookmakers différents. Cependant, vous ne pouvez avoir qu\'un seul compte par bookmaker. L\'ouverture de plusieurs comptes chez le même opérateur est interdite.',
    },
  ];

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />

      <div className="min-h-screen pt-20">
        <section className="py-20">
          <div className="container mx-auto px-4">
            <h1 className="text-5xl font-bold text-white text-center mb-4">
              Questions Fréquentes
            </h1>
            <p className="text-center text-dark-muted text-xl mb-12 max-w-3xl mx-auto">
              Trouvez les réponses aux questions les plus courantes sur les paris sportifs en
              France.
            </p>

            <div className="max-w-3xl mx-auto space-y-4">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="bg-dark-card border border-dark-border rounded-lg overflow-hidden hover:border-accent-primary transition-all"
                >
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    className="w-full px-6 py-4 flex items-center justify-between text-left"
                  >
                    <span className="text-white font-semibold text-lg pr-4">
                      {faq.question}
                    </span>
                    {openIndex === index ? (
                      <FiChevronUp className="text-accent-primary flex-shrink-0" size={24} />
                    ) : (
                      <FiChevronDown className="text-dark-muted flex-shrink-0" size={24} />
                    )}
                  </button>
                  {openIndex === index && (
                    <div className="px-6 pb-4 text-dark-muted leading-relaxed animate-fade-in">
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FAQ;

